import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';

import { createDyzioEvent } from './dyzioevents';
import { CAMPAIGN_OWNER } from './static-configuration';

const CAMPAIGN_VERSION_TWO = 2;
const CLIENT_BRIEF_URL =
 'https://s3-eu-west-1.amazonaws.com/cf-templates-o6s432he4qgr-eu-west-1/2016202Jd5-dyzio-aws-stack.json';

const FREEMIUM = 'FREE';
const CREATE_CAMPAIGN_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/campaigns';
/*
  Wouldn't it be nice if this was all in a lambda?
*/

export default ({
  name,
  budget,
  liveDate,
  endDate,
  currency,
  hashtags,
  campaignType,
  brand,
  country,
  jsonAPIClient,
  userInfo: { email, userId, organisationId },
  organisation,
  scanUnauthorisedStories,
  useEstimatedReachAndImpressions,
  shortlistId,
}) => {
  const campaign = jsonAPIClient.create('campaigns');

  const fields = {
    name,
    budget,
    campaignType: 'AUTOMATED',
    memberCount: 1,
    version: CAMPAIGN_VERSION_TWO,
    clientBrief: CLIENT_BRIEF_URL,
    currency,
    hashtags,
    description: `Description generated at ${moment().toISOString()}`,
    approvalStatus: 'PENDING',
    country,
    scanUnauthorisedStories,
    useEstimatedReachAndImpressions,
  };

  if (organisation && organisation.licenseSubscriptionType === FREEMIUM) {
    console.log('blocking premium features');
    fields.premiumFeaturesBlocked = true;
  }

  _.forEach(fields, (value, key) => {
    if (value) {
      campaign.set(key, value);
    }
  });

  if (liveDate) {
    campaign.set('liveDate', liveDate.toISOString());
  }

  if (endDate) {
    campaign.set('endDate', endDate.toISOString());
  }

  if (shortlistId) {
    campaign.set('shortlist', { type: 'shortlists', id: shortlistId });
  }

  const safeBrand = _.trim(brand);

  if (safeBrand) {
    campaign.set('brand', safeBrand);
  }

  return campaign.sync()
    .then(async response => {
      const campaignResource = _.clone(response);
      const campaignJSON = response.toJSONTree();

      // if it's a shortlist >> campaign creation, fire request
      if (shortlistId) {
        const createUrl = `${CREATE_CAMPAIGN_API}/${campaignJSON.id}/shortlists/${shortlistId}`;
        console.log(createUrl);
        axios.post(createUrl);
      }

      // Create campaign permission
      const campaignPermission = jsonAPIClient.create('campaignPermission');
      campaignPermission.set('campaign', { type: 'campaigns', id: campaignJSON.id });
      campaignPermission.set('user', { type: 'users', id: userId });
      campaignPermission.set('organisation', { type: 'organisations', id: organisationId });
      campaignPermission.set('email', email);
      campaignPermission.set('role', CAMPAIGN_OWNER);
      campaignPermission.set('sendDailyNotifications', true);
      campaignPermission.set('sendWeeklyNotifications', true);
      campaignPermission.set('status', 'ACTIVE');
      return Promise.all([
        Promise.resolve(campaignResource),
        campaignPermission.sync(),
      ]);
    })
    .then(([campaignResource, campaignPermissionResponse]) => {
      const campaignPermissionResource = _.clone(campaignPermissionResponse);
      campaignResource.relationships('members').add(campaignPermissionResource);
      return campaignResource.sync();
    })
    .then(response => {
      const { id } = response.toJSONTree();
      const path = `${campaignType === 'ACR' ? '/acr-' : '/'}campaign/${id}`;
      window.location = path;
      return createDyzioEvent({
        message: 'Campaign was created',
        organisationId,
        campaignId: id,
        jsonAPIClient,
      });
    });
};



/** WEBPACK FOOTER **
 ** ./src/utils/create-new-campaign.js
 **/